import { takeEvery, put, call } from 'redux-saga/effects';
import { Creators, Types } from 'src/store/redux/statistics-tpa/actions';
import statisticsAPI from 'src/services/api/statistics';
import { handleErrorResponse } from 'src/lib/helpers/errors';
import { DBErrorMonitor } from 'src/services/error-monitor';

export function* getSla(filters: any = null) {
  try {
    // @ts-ignore: Unreachable code error
    
    const response = yield call(statisticsAPI.slaSection, filters);
    yield put(
      Creators.statisticsSlaRequestSuccess(response.data)
    );
  } catch (e) {
    let error = e;
    DBErrorMonitor.captureException(e, {
      saga: 'getSla',
      entity: 'statistics',
    });
    handleErrorResponse(error);
    yield put(Creators.statisticsSlaRequestError(error));
  }
}

export function* watchGetSla() {
  yield takeEvery(
    Types.STATISTICS_SLA_REQUEST,
    getSla
  );
}

export default watchGetSla;
